import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { ICountryInfoApi } from "./base/countryInfoApi";
import { CountryInfoResponse } from "../models/response/countryInfoResponse";

const baseRoute: string = "CountryInfo";

export class CountryInfoApi extends ICountryInfoApi {
	getCountryInfo(guidCountry: string): Promise<AxiosResponse<Result<CountryInfoResponse>>> {
		return api.get(`${baseRoute}/domain`, {
			params: { guidCountry },
		});
	}

	getCountryInfoPublic(guidCountry: string): Promise<AxiosResponse<Result<CountryInfoResponse>>> {
		return api.get(`${baseRoute}/domain_public`, {
			params: { guidCountry },
		});
	}
}
